import type {PropertySourceDetails} from '@github-ui/custom-properties-types'
import {GearIcon} from '@primer/octicons-react'
import {Banner, LinkButton} from '@primer/react'

type Props = {
  definitionSource: PropertySourceDetails
  definitionDetailsPath: string
  viewerCanManage: boolean
  className?: string
}

export function PropertyManagementBanner({definitionSource, definitionDetailsPath, viewerCanManage, className}: Props) {
  const sourceTypeLabel = definitionSource.type === 'business' ? 'enterprise' : 'organization'
  return (
    <Banner
      className={className}
      title="Read only definition"
      hideTitle
      primaryAction={
        viewerCanManage && (
          <LinkButton leadingVisual={GearIcon} href={definitionDetailsPath}>
            {`Manage in ${sourceTypeLabel}`}
          </LinkButton>
        )
      }
    >
      This property is managed by {definitionSource.name} and can&apos;t be edited here.
    </Banner>
  )
}
